import { useCallback, useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useBranch = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getBranches = useCallback(async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/branch`,
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
        });

        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  }, [authCtx, sendRequest]);

  const getAllEntertainmentsOfBranches = useCallback(async branchIds => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/branch/allentertainments`,
          method: 'POST',
          body: { branches: branchIds },
          headers: authCtx.getAuthHeaders(),
        });

        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  }, [authCtx, sendRequest]);

  const getEmployeeCardStock = useCallback(async () => {
    return await sendRequest({
      url: '/api/v1/branch/employee-card-stock',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
  }, [authCtx, sendRequest]);

  const addEmployeeCardShipment = useCallback(async (branchId, payload) => {
    return await sendRequest({
      url: `/api/v1/branch/${branchId}/employee-card-stock/shipment`,
      method: 'POST',
      headers: authCtx.getAuthHeaders(),
      body: payload,
    });
  }, [authCtx, sendRequest]);

  const reportEmployeeCardMisprint = useCallback(async (branchId, payload) => {
    return await sendRequest({
      url: `/api/v1/branch/${branchId}/employee-card-stock/misprint`,
      method: 'POST',
      headers: authCtx.getAuthHeaders(),
      body: payload,
    });
  }, [authCtx, sendRequest]);

  return {
    isLoading,
    error,
    getBranches,
    getAllEntertainmentsOfBranches,
    getEmployeeCardStock,
    addEmployeeCardShipment,
    reportEmployeeCardMisprint,
  };
};

export default useBranch;
